import { z } from 'zod';

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

const nameRequiredMsg = {
  id: 'tagGroups.validation.nameRequired',
  defaultMessage: 'Name is required',
};
const tagsRequiredMsg = {
  id: 'tagGroups.validation.tagsRequired',
  defaultMessage: 'At least one tag is required',
};
const onlyOneDefaultMsg = {
  id: 'tagGroups.validation.onlyOneDefault',
  defaultMessage: 'Only one group can be set as default',
};

export function getTagGroupSchema(t: MessageFormatter) {
  return z.object({
    name: z.string().min(1, t(nameRequiredMsg)),
    tags: z.array(z.string()).min(1, t(tagsRequiredMsg)),
    default: z.boolean(),
  });
}

export function getSchema(t: MessageFormatter) {
  const tagGroupSchema = getTagGroupSchema(t);
  return z
    .object({
      tagGroups: z.array(tagGroupSchema),
    })
    .refine((data) => data.tagGroups.filter((group) => group.default).length <= 1, {
      message: t(onlyOneDefaultMsg),
      path: ['tagGroups', 'root'],
    });
}

/** @deprecated Use getSchema(t) for translated messages */
export const tagGroupSchema = getTagGroupSchema((msg) => msg.defaultMessage);

/** @deprecated Use getSchema(t) for translated messages */
export const schema = getSchema((msg) => msg.defaultMessage);

export type TagGroupsFormValues = z.infer<ReturnType<typeof getSchema>>;
